import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EntrySelect } from 'src/app/shared/models/EntrySelect.model';
import { Orcamento } from '../../veiculo/shared/model/orcamento.model';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { VeiculoService } from '../../../shared/services/veiculo.service';
import { MessageService } from 'src/app/shared/message.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-validacao-consulta',
  templateUrl: './validacao-consulta.component.html',
  styleUrls: ['./validacao-consulta.component.css']
})
export class ValidacaoConsultaComponent implements OnInit {
  marcas: Array<EntrySelect> = [];
  geracoes: Array<EntrySelect> = [];
  versoes: Array<EntrySelect> = [];
  modelos: Array<EntrySelect> = [];
  veiculos: Array<EntrySelect> = [];
  resourceForm: FormGroup;
  logo_marca: string;
  model: any = new Orcamento;
  listaMarcas: Array<any>;
  fipe: string = null;
  isReadOnly: boolean = false;
  constructor(
    public bsModalRef: BsModalRef,
    private restCiclo: VeiculoService,
    private info: MessageService,
    private formBuilder: FormBuilder,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.resourceForm = this.formBuilder.group({
      marca: [null, [Validators.required]],
      geracao: [null, [Validators.required]],
      modelo: [null, [Validators.required]],
      versao: [null, [Validators.required]],
      veiculo: [null, [Validators.required]],
      placa_auto: [null, [Validators.nullValidator]],
    });
    this.loadMarcas();
  }


  fechaModalVersao() {
    $('#modal-versoes').addClass('none')
  }

  consultaPlaca() {
    let placa = this.resourceForm.get('placa_auto')?.value;
    if (placa == null || placa == "") {
      this.info.showErro("É necessário informar a Placa do veículo, para realizar a consulta");
    }
    else {
      new Promise((resolve) => {
        this.restCiclo.getPlacas(placa).subscribe((data) => {
          if (data.data.base12 == undefined) {
            this.info.showErro(data.data.msg);
          }
          else {

            if (data.data.base12[0].bdpecas != 'Sim') {
              $('#sem-pcs').css('display', '');
            }

            this.resourceForm.get('marca')?.setValue(data.data.base12[0].codigoMarca);
            resolve(this.onChangeMarca(event));
            this.resourceForm.get('geracao')?.setValue(data.data.base12[0].codigoGeracao);
            resolve(this.onChangeGeracao(event));
            this.resourceForm.get('modelo')?.setValue(data.data.base12[0].codigoModelo);
            resolve(this.loadModelos(this.resourceForm.get('geracao')?.value));
            // this.resourceForm.get('versao')?.setValue(data.data.base12[0].codigoVersao);
            //this.resourceForm.get('veiculo')?.setValue(data.data.base12[0].codigoVeiculo);

            this.versoes = [];
            //console.log(data)
            data.data.base12.forEach(item => {
              //console.log(item)
              this.versoes.push({ "value": item.codigoVersao, "label": item.versionCiclo, "value_other": item.bdpecas });
            });
            this.resourceForm.get('versao').setValue(data.data.base12[0].codigoVersao);
            this.model.versao_nome = data.data.base12[0].versionCiclo;
            this.loadVeiculos();

            //jgq8424
            //console.log(this.versoes);
            //this.loadVersoes(this.resourceForm.get('modelo')?.value);
            //resolve(this.onChangeVersao(event));
            //this.resourceForm.get('veiculo')?.setValue(data.data.base12[0].codigoVeiculo);
            this.resourceForm.get('placa')?.setValue(String(this.resourceForm.get('placa_auto').value).toUpperCase());
            this.resourceForm.get('placa_auto').setValue(null);
            this.resourceForm.get('chassi')?.setValue(data.data.chassi);
            this.resourceForm.get('tipo_combustivel')?.setValue(data.data.combustivel);
            this.model.marca_nome = data.data.fabricante;
            this.model.geracao_nome = data.data.base12[0].geracao;
            this.model.modelo_nome = data.data.base12[0].modeloCiclo;
            //this.model.versao_nome = data.data.base12[0].versionCiclo;
            this.model.veiculo_nome = data.data.base12[0].anoveiculoCiclo;
            //console.log(data.data);
          }
        })
      })
    }
  }


  alertaConsultaPlaca() {
    this.info.showAlert('A busca por placa preenche de forma automárica os campos de Marca, Geração e Modelo')
  }

  onChangeMarca(event) {
    if (event) {
      this.marcas.forEach((e) => {
        if (e.value == event) this.model.marca_nome = e.label;
      });
      this.loadGeracao()
      this.resourceForm.get('geracao')?.setValue(null);
      this.resourceForm.get('modelo').setValue(null);
      this.resourceForm.get('versao').setValue(null);
      this.resourceForm.get('veiculo').setValue(null);
      this.geracoes = [];
      this.modelos = [];
      this.versoes = [];
      this.veiculos = [];
    }
    else {
      this.resourceForm.get('geracao')?.setValue(null);
      this.resourceForm.get('modelo').setValue(null);
      this.resourceForm.get('versao').setValue(null);
      this.resourceForm.get('veiculo').setValue(null);
      this.geracoes = [];
      this.modelos = [];
      this.versoes = [];
      this.veiculos = [];
    }
  }

  onChangeGeracao(event) {
    if (event) {
      this.geracoes.forEach((g) => {
        if (g.value == event) this.model.geracao_nome = g.label
      });
      //this.model.geracao_nome = event ? event.label : null;
      //console.log(this.resourceForm.get('geracao'));
      this.loadModelos(event)
      //this.loadModelos(event.value)
      this.resourceForm.get('modelo')?.setValue(null);//clean value}
    }
    else {
      this.resourceForm.get('modelo').setValue(null);
      this.resourceForm.get('versao').setValue(null);
      this.resourceForm.get('veiculo').setValue(null);
      this.modelos = [];
      this.versoes = [];
      this.veiculos = [];
    }
  }


  loadMarcas() {
    this.restCiclo.getMarcas().subscribe(
      data => {
        var res = JSON.parse(JSON.stringify(data));
        var returnMarcas = res.data;
        this.listaMarcas = res.data;
        this.marcas = [];
        returnMarcas.forEach(item => {
          if (item.bdPecas == 'Nao') {
            this.marcas.push({ "value": item.codigoMarca, "label": item.descricaoMarca, "value_other": 'Sem Peças' })

          } else {
            this.marcas.push({ "value": item.codigoMarca, "label": item.descricaoMarca })
          }
        });
      }
    )
  }

  loadGeracao() {
    let idSetMarca = this.resourceForm.get('marca')?.value
    if (idSetMarca == "" || idSetMarca == null) {
      this.geracoes = []
      return
    }
    this.restCiclo.getMarca(idSetMarca.toString()).subscribe(
      data => {
        this.geracoes = []
        this.logo_marca = data.data.link
        if (data.data.status != 404)
          data.data.geracoes.forEach(item => {

            if (item.bdPecas == 'Nao') {
              this.geracoes.push({ "value": item.codigoGeracao, "label": item.descricaoGeracao, "value_other": 'Sem Peças' })

            } else {
              this.geracoes.push({ "value": item.codigoGeracao, "label": item.descricaoGeracao })
            }
          })
      }
    )
  }

  loadModelos(valor) {/* AQUI */
    //ese set não pode
    //this.resourceForm.value.geracao == valor
    let idGeracao = valor
    //console.log("setGera"+" "+idGeracao)
    if (valor == "" || valor == null) {
      this.modelos = []
      return
    }
    this.restCiclo.getGeracao(idGeracao).subscribe(
      data => {
        this.modelos = []

        let dados: Array<any> = [];
        data.data.modelos ? dados = data.data.modelos : dados = data.data;
        dados.forEach(item => {
          //if (item.bdPecas == 'Nao') {
          this.modelos.push({ "value": item.codigoModelo, "label": item.descricaoModelo, "value_other": (item.bdPecas == 'Nao') ? 'Sem Peças' : '' })

          //} else {
          //this.modelos.push({ "value": item.codigoModelo, "label": item.descricaoModelo, "value_other": 'Sem Peças' })
          //}
        })
      }
    )
  }

  loadVersoes(valor, checkar: boolean = true) {
    // this.resourceForm.value.versao = valor.toString()
    let idModelo = valor
    //console.log("setModelo"+" "+idModelo)

    if (valor == "") {
      this.versoes = []
      return
    }
    //console.log(valor)
    this.restCiclo.getModelo(idModelo).subscribe(
      data => {
        this.versoes = []

        data.data.versoes.forEach(item => {
          //console.log(item)
          // this.versoes.push({ "value": item.codigoVersao, "label": item.descricaoVersao })

          if (item.bdPecas == 'Nao') {
            this.versoes.push({ "value": item.codigoVersao, "label": item.descricaoVersao, "value_other": 'Sem Peças' })

          } else {
            this.versoes.push({ "value": item.codigoVersao, "label": item.descricaoVersao })
          }


        })
        if (data.data.bdPecas == 'Nao' && checkar) {
          this.info.customAlert({
            icon: 'info',
            title: 'Informação',
            text: 'Identificamos que o veículo selecionado não possuim peças para seleção automática',
            timer: 20000,
            timerProgressBar: true,
            showConfirmButton: true,
            confirmButtonText: 'OK'
          });
        }
      }
    )
  }

  loadVeiculos() {
    ''
    let idVersao = this.resourceForm.get('versao')?.value

    if (idVersao == "") {
      this.veiculos = []
      return
    }

    this.restCiclo.getVersao(idVersao).subscribe(
      data => {
        this.veiculos = [];
        data.data.veiculos.forEach(item => {
          //console.log(item)
          this.veiculos.push({
            "value": item.codigoVeiculo, "label": item.anoModelo, "value_other": item.valorFipe
          });
          this.veiculos.sort((a: any, b: any) => a.label - b.label);
        })
        if (this.veiculos.length == 1) {
          this.resourceForm.get('veiculo')?.setValue(this.veiculos[0].value);
          let aux: EntrySelect = { "label": this.veiculos[0].label, "value": this.veiculos[0].value, "value_other": this.veiculos[0].value_other }
          this.onChangeVeiculo(aux)
        }
      }
    )
  }

  selecionaVersaoModal(id, label) {
    //console.log('id: ', id, ' label: ', label);
    this.resourceForm.get('versao').setValue(id);
    this.onChangeVersao({ 'label': label })
    this.fechaModalVersao();
  }


  onChangeVersao(event) {
    //console.log(event)
    if (event) {
      this.model.versao_nome = event ? event.label : null;
      this.loadVeiculos()
      this.resourceForm.get('veiculo')?.setValue(null);//clean value
    }
    else {
      this.loadVersoes(this.resourceForm.get('modelo').value);
      this.resourceForm.get('veiculo').setValue(null);
      this.veiculos = [];
    }
  }

  onChangeVeiculo(event) {
    this.model.veiculo_nome = event ? event.label : null;
    this.model.fipe = event ? event.value_other : null;
    this.fipe = event ? event.value_other : null
  }

  onChangeModelo(chekar: boolean = true) {
    let event = this.obterDadosModelo(this.resourceForm.get('modelo').value)
    //console.log(event)
    if (event) {
      //console.log(event)
      this.model.modelo_nome = event ? event.label : null;
      //console.log(this.model.modelo_nome)
      this.loadVersoes(event.value, chekar)
      this.resourceForm.get('versao')?.setValue(null);//clean value
    }
    else {
      this.resourceForm.get('versao').setValue(null);
      this.resourceForm.get('veiculo').setValue(null);
      this.versoes = [];
      this.veiculos = [];
      this.loadModelos(this.resourceForm.get('geracao'));
    }
  }
  obterDadosModelo(modelo) {
    for (let i = 0; i < this.modelos.length; i++) {
      if (this.modelos[i].value == modelo) {
        return { "value": this.modelos[i].value, "label": this.modelos[i].label }
      }
    }
  }

  abrirConsultaDePecas() {
    if (this.resourceForm.invalid) {
      //console.log(this.resourceFormPeca)
      this.resourceForm.markAllAsTouched();
      return;
    }
    let dadosOriginais: any = {};
    dadosOriginais.dataCar = {
      "placa": null,
      "chassi": null,
      "quilometragem": null,
      "marcaCodigo": this.model.marca,
      "marcaDescricao": this.model.marca_nome,
      "geracaoCodigo": this.model.geracao,
      "geracaoDescricao": this.model.geracao_nome,
      "modeloCodigo": this.model.modelo,
      "modeloDescricao": this.model.modelo_nome,
      "versaoCodigo": this.model.versao,
      "versaoDescricao": this.model.versao_nome,
      "veiculoCodigo": this.model.veiculo,
      "veiculoDescricao": this.model.veiculo_nome,
      "veiculoCor": null,
      "veiculoNivelCombustivel": null,
      "link": this.obterLogo(),
      "fipe": this.fipe
    }
    //send Rest
    let d = (dadosOriginais)
    this.bsModalRef.hide();
    this.router.navigateByUrl('/consulta', { state: { dados: d } });
  }

  obterLogo() {
    if (!this.isReadOnly) {
      let cod = this.model.marca;
      for (let i = 0; i < this.listaMarcas.length; i++) {
        if (this.listaMarcas[i].codigoMarca == cod) {
          return this.listaMarcas[i].link;
        }
      }
    }
    return null
  }
}
